interface ImageBlockProps {
  content: {
    url?: string;
    caption?: string;
    alignment?: "center" | "left" | "right";
  };
}

export function ImageBlock({ content }: ImageBlockProps) {
  const alignClass =
    content.alignment === "left"
      ? "mr-auto"
      : content.alignment === "right"
        ? "ml-auto"
        : "mx-auto";

  return (
    <section className="mx-auto max-w-[1200px] px-6 py-16">
      <figure className={`max-w-full ${alignClass}`}>
        {content.url && (
          <img
            src={content.url}
            alt={content.caption || ""}
            className="w-full object-cover"
          />
        )}
        {content.caption && (
          <figcaption className="mt-4 font-sans text-sm text-muted-foreground">
            {content.caption}
          </figcaption>
        )}
      </figure>
    </section>
  );
}
